<!-- <router-outlet></router-outlet> -->
<div id="all" [class]="'fullHD roboto step_'+step" [class.help]="help" *ngIf="datas && (!isVP)" (click)="onClick()">

  <div class="map fullHD" (click)="onClickMap($event)">
    <div class="answer" *ngFor="let answer of answers">
      <div class="error" *ngIf="answer.error.px != 0" [style.top]="answer.user.y+'px'" [style.left]="answer.user.x+'px'" [style.width]="answer.error.px+'px'" [style.transform]="'rotate('+answer.error.angle+'rad)'" [style.borderColor]="espace.color"></div>
      <div class="user" *ngIf="answer.error.px != 0" [style.top]="answer.user.y+'px'" [style.left]="answer.user.x+'px'" [style.color]="espace.color"><svg version="1.1" width="30px" height="46px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 32" style="enable-background:new 0 0 24 32;" xml:space="preserve"><path class="st0" d="M12,1C5.79,1,0.75,6.04,0.75,12.25C0.75,20.34,12,31,12,31s11.25-10.66,11.25-18.75C23.25,6.04,18.21,1,12,1z M17.64,19.01c-0.22,0.22 0.5,0.34-0.81,0.34c-0.31,0-0.59-0.12-0.81-0.34l-3.97-3.97l-3.97,3.97c-0.43,0.43-1.19,0.43-1.62,0 c-0.22-0.22-0.34-0.5-0.34-0.81s0.12-0.59,0.34-0.81l3.97-3.97L6.46,9.45c-0.22-0.22-0.34-0.5-0.34-0.81c0-0.31,0.12-0.59,0.34-0.81 l0.25,0.25L6.46,7.83c0.45-0.45,1.17-0.45,1.62,0l3.97,3.97l3.97-3.97c0.45-0.45,1.18-0.45,1.62,0c0.45,0.45,0.45,1.18,0,1.62 l-3.97,3.97l3.97,3.97c0.22,0.22,0.34,0.5,0.34,0.81S17.86,18.8,17.64,19.01z"/></svg></div>
      <div class="correct" [style.top]="answer.correct.y+'px'" [style.left]="answer.correct.x+'px'" [style.color]="espace.color"><svg version="1.1" width="30px" height="46px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 24 32" style="enable-background:new 0 0 24 32;" xml:space="preserve">
        <path class="st0" d="M12,1C5.79,1,0.75,6.04,0.75,12.25C0.75,20.34,12,31,12,31s11.25-10.66,11.25-18.75C23.25,6.04,18.21,1,12,1z
        M18.47,9.77l-6.45,7.97c-0.46,0.48-1.22,0.51-1.71,0.06c-0.01-0.01-0.02-0.02-0.03-0.03L6,13.54c-0.49-0.45-0.52-1.21-0.06-1.69
        c0.46-0.48,1.22-0.51,1.71-0.06c0.02,0.02,0.04,0.04,0.06,0.06l3.38,3.34l5.61-7.07c0.01-0.01,0.02-0.02,0.03-0.04h0
        c0.48-0.47,1.24-0.46,1.71,0.01C18.92,8.56,18.92,9.3,18.47,9.77z"/></svg>
      </div>
      <div class="picture" 
        [style.top]="answer.correct.y+'px'"
        [style.left]="answer.correct.x+'px'"
        [style.borderColor]="espace.color"
        [style.backgroundImage]="answer.question.sanitizedImage"
      ></div>
    </div>
  </div>

  <div id="splash" class="page roboto fullHD" *ngIf="current == 'splash'" (click)="onSplashClick()" [style.background]="bgImage">
    <div class="group">
      <div class="title suburban"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div>
      <div class="baseline">
        <span [innerHTML]="datas.baseline">...</span>
        <span class="picto" *ngIf="espace" [style.backgroundColor]="espace.color">
          <svg width="1em" height="1em" viewBox="0 0 27 33" class="bi bi-play-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          	<g>
          		<path class="st0" d="M12.39,10.74c0-2.09,0.05-4.5-0.03-6.9c-0.03-0.64-0.29-1.52-0.76-1.84c-0.56-0.38-1.65-0.59-2.15-0.3
          			C8.83,2.07,8.19,3.03,8.17,3.76c-0.12,4.47-0.05,8.93-0.08,13.4c0,0.46-0.34,0.9-0.52,1.36c-0.37-0.27-0.81-0.5-1.05-0.85
          			c-0.55-0.81-0.91-1.74-1.48-2.53c-0.64-0.91-1.6-1.19-2.59-0.66c-1.01,0.55-0.84,1.42-0.41,2.32c2.12,4.51,4.19,9.05,6.36,13.54
          			c0.24,0.5,1.04,1.05,1.57,1.05c3.98,0.09,7.94,0.06,11.92,0.05c2-0.02,3.35-1.37,3.37-3.37c0.03-3.8,0.05-7.59-0.03-11.39
          			c-0.02-0.67-0.43-1.46-0.91-1.94c-0.37-0.35-1.19-0.47-1.72-0.35c-0.56,0.14-1.05,0.67-1.59,1.05c0.02-1.27,0.06-2.56-1.42-3.16
          			c-1.22-0.49-2.01,0.18-2.91,1.16c0.09-1.49,0.06-2.93-1.42-3.26C14.39,10,13.37,10.53,12.39,10.74z"/>
          		<path class="st0" d="M12.39,10.74c0.98-0.21,2-0.75,2.87-0.56c1.48,0.32,1.51,1.77,1.42,3.26c0.9-0.96,1.69-1.65,2.91-1.16
          			c1.48,0.59,1.42,1.89,1.42,3.16c0.55-0.38,1.02-0.93,1.59-1.05c0.53-0.12,1.36-0.02,1.72,0.35c0.49,0.47,0.9,1.27,0.91,1.94
          			c0.09,3.8,0.06,7.59,0.03,11.39c-0.02,2.01-1.37,3.35-3.37,3.37c-3.98,0.03-7.96,0.05-11.92-0.05c-0.55-0.02-1.33-0.55-1.57-1.05
          			c-2.16-4.48-4.24-9.02-6.36-13.54c-0.43-0.91-0.59-1.78,0.41-2.32c0.99-0.53,1.95-0.26,2.59,0.66c0.56,0.79,0.93,1.72,1.48,2.53
          			c0.24,0.37,0.7,0.58,1.05,0.85c0.18-0.46,0.52-0.9,0.52-1.36c0.05-4.47-0.03-8.93,0.08-13.4c0.02-0.73,0.66-1.69,1.28-2.07
          			c0.5-0.3,1.59-0.08,2.15,0.3c0.47,0.32,0.75,1.2,0.76,1.84C12.44,6.25,12.39,8.66,12.39,10.74z"/>
          	</g>
          </svg>
        </span>
      </div>
    </div>
  </div>

  <div class="instruction fullHD absolute" *ngIf="current == 'introduction'" (click)="onInstructionClick()">
    <div class="bloc absolute">
      <div class="inner">
        <h1 [innerHTML]="datas.introduction_title" class="suburban"></h1>
        <div class="details table">
          <div class="cell" [innerHTML]="datas.introduction_description"></div>
          <div class="center">
            <a (click)="onInstructionClick()" class="next suburban">
                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" class="bi bi-caret-right-fill" viewBox="0 0 16 16">
    <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
  </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="game" *ngIf="current == 'game'">
    <div class="dots">
      <div class="dot" *ngFor="let lieu of deck; let i = index;" [class.old]="i<selected" [class.on]="i==selected"></div>
    </div>
    <div class="box question">
      <!-- <div class="title"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div> -->
      <div class="inner">
        <div class="question" *ngIf="selected != -1">
          <div class="text" [innerHTML]="deck[selected]?.title"></div>
          <img [src]="image" alt="">
          <div class="response" [innerHTML]="deck[selected]?.response"></div>
          <div class="description" [innerHTML]="deck[selected]?.description"></div>
        </div>
        <div class="end">
          <p class="comment" [innerHTML]="conclusion"></p>
          <!-- <div class="total suburban" [innerHTML]="formatNombre(total)+' km'"></div> -->
          <div class="toknow" [innerHTML]="toknow"></div>
        </div>
      </div>
      <a class="picto next" (click)="onClickBox()" [style.backgroundColor]="espace.color"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-down-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></a>
      <a class="picto restart" (click)="onRestart()" [style.backgroundColor]="espace.color"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-arrow-counterclockwise" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 3a5 5 0 1 1-4.546 2.914.5.5 0 0 0-.908-.417A6 6 0 1 0 8 2v1z"/><path d="M8 4.466V.534a.25.25 0 0 0-.41-.192L5.23 2.308a.25.25 0 0 0 0 .384l2.36 1.966A.25.25 0 0 0 8 4.466z"/></svg></a>
    </div>

    <div class="howto_help" *ngIf="selected != -1">
      <div class="howto">
        <div class="pointer" [style.color]="espace.color"><svg width="30px" height="46px" viewBox="0 0 16 16" class="bi bi-geo-alt-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M8 16s6-5.686 6-10A6 6 0 0 0 2 6c0 4.314 6 10 6 10"/></svg></div>
        <p [innerHTML]="datas?.instruction"></p>
      </div>
      <div class="help">
        <a (click)="onHelp()" [style.backgroundColor]="espace.color" [innerHTML]="datas?.btn_help"></a>
        <p [innerHTML]="deck[selected].indice">...</p>
      </div>
    </div>

    <div class="box result" *ngIf="answers.length">
      <!-- <div class="title"><span [innerHTML]="datas.title" [style.backgroundColor]="espace.color">...</span></div> -->
      <div class="inner">
        <div class="text" [innerHTML]="answers[answers.length-1].error.msg"></div>
        <div class="total" [innerHTML]="total_msg"></div>
      </div>
      <a class="picto" (click)="onClickResult()" [style.backgroundColor]="espace.color"><svg width="1em" height="1em" viewBox="0 0 16 16" class="bi bi-caret-down-fill" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path d="M7.247 11.14L2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/></svg></a>
    </div>

    <a class="homeBtn" (click)="goHome()">
      <svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" style="enable-background:new 0 0 16 16;" xml:space="preserve">
        <style type="text/css">
          .white{fill:#FFFFFF;}
        </style>
        <path class="white" d="M14,15c0.28,0,0.5-0.22,0.5-0.5v-7c0-0.13-0.05-0.26-0.15-0.35l-6-6c-0.2-0.2-0.51-0.2-0.71,0l0,0l-6,6
        C1.55,7.24,1.5,7.37,1.5,7.5v7C1.5,14.78,1.72,15,2,15H14z"/>
      </svg>
    </a>

  </div>
</div>
